import { render, staticRenderFns } from "./RegisterMember.vue?vue&type=template&id=792cc170"
import script from "./RegisterMember.vue?vue&type=script&lang=js"
export * from "./RegisterMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports